<template>
  <div id="app">
    <!-- <keep-alive> -->
    <router-view :key="$route.fullPath" />
    <!-- </keep-alive> -->
       <!-- 微信客服组件 -->
       <WechatCustomerService
      :kfUrl="wechatKfUrl"
      :visible="true"
      pcOffsetRight="2px"
      pcOffsetBottom="30px"
    />
    <BackToTop v-if="showBackToTop" />
  </div>
</template>

<script>
import WechatCustomerService from '@/components/WechatCustomerService.vue'
import BackToTop from '@/components/BackToTop.vue'
export default {
  name: 'App',
  data() {
    return {
      key: '',
      showBackToTop:true,
      wechatKfUrl: 'https://work.weixin.qq.com/kfid/kfc9b45b0fbe4693c86'
    }
  },
  components:{
  WechatCustomerService,
  BackToTop
  },

  watch: {
    '$route'(to, from) {
      try {
        //console.log("to ================ ", to)
        //console.log("from ================ ", from)
        this.$store.commit('SET_breadcrumbData',[]);
      } catch (error) {
        //console.log("error ======", error)
      }
      // //console.log("to ================ ",to)
      // //console.log("from ================ ",from)

      // this.$router.go(0)
      // if (to.query !== from.query  ) {
      //  // this.$router.go(to);

      // }
      // if(to !== from)
      //  this.$router.go(to);
    }
  },
  created() {
    // 在页面加载时读取 sessionStorage 里的状态信息
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem('store'))
        )
      );
    }
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state));
    });
  },

  methods: {
    loadData(id) {
      // 重新加载数据
      // fetchProduct(id).then(data => {
      //   this.product = data
      // })
    }
  }
}
</script>

<style lang="scss">
#app {
  font-family: 'Segoe UI', 'Microsoft YaHei', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2e2e2e;
}

</style>